import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { CURRENCY } from 'helpers/utils'
import React from 'react'

export const CurrencyInput = ({ value, onChange, label = 'Валюта', options = {} }) => {
    const disabled = options.disabled || false;

    return (
        <FormControl fullWidth>
            <InputLabel shrink>{label}</InputLabel>
            <Select
                label={label}
                InputLabelProps={{
                    shrink: true,
                }}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                disabled={disabled}
            >
                {Object.values(CURRENCY).map(c => {
                    return <MenuItem key={c} value={c}>{c}</MenuItem>
                })}
            </Select>
        </FormControl>
    )
}
